import {
    Avatar, Badge,
    Flex,
    HStack,
    IconButton,
    Menu,
    MenuButton, MenuDivider, MenuItem,
    MenuList,
    Text,
    useColorModeValue,
    VStack
} from "@chakra-ui/react";
import {FiMenu} from "react-icons/fi";
import {PiButterflyFill} from "react-icons/pi";
import {ColorModeSwitcher} from "../../ColorModeSwitcher";
import ProjectTitle from "../ProjectTitle";

export const MobileNav = ({titleComponent, isOpen, onOpen, ...rest}) => {
    return (
        <Flex
            ml={{base: 0, md: 60}}
            px={{base: 4, md: 4}}
            height="20"
            alignItems="center"
            borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
            justifyContent={{base: 'space-between', md: 'flex-end'}}
            gap={4}
            {...rest}>
            <IconButton
                display={{base: 'flex', md: 'none'}}
                onClick={onOpen}
                variant="outline"
                aria-label="open menu"
                icon={<FiMenu/>}
            />
            <Flex flexDirection={"row"} w={"full"} alignItems={"center"} gap={2} display={{base: "flex", md: "none"}}>
                <Text fontSize="2xl"><PiButterflyFill/></Text>
                <Text fontSize="2xl" fontFamily="monospace" fontWeight="bold">
                    Butterfly
                </Text>
            </Flex>

            {titleComponent}


            <HStack spacing={{base: '2', md: '6'}}>
                <ColorModeSwitcher/>
                <Flex alignItems={'center'}>
                    <Menu>
                        <MenuButton py={2} transition="all 0.3s" _focus={{boxShadow: 'none'}}>
                            <HStack>
                                <Avatar
                                    size={'md'}
                                    src={
                                        'https://i.pinimg.com/originals/78/a3/bd/78a3bda4f67d0b19b653f1882df25cd7.png'
                                    }
                                />
                                <VStack
                                    display={{base: 'none', md: 'flex'}}
                                    alignItems="flex-start"
                                    spacing="1px"
                                    ml="2"
                                    mr={8}
                                >
                                    <Text fontSize="sm">Abhijith Mergu</Text>
                                    <Text fontSize="xs" color="gray.600">
                                        Admin
                                    </Text>
                                </VStack>
                            </HStack>
                        </MenuButton>
                        <MenuList
                            bg={useColorModeValue('white', 'gray.900')}
                            borderColor={useColorModeValue('gray.200', 'gray.700')}>
                            <MenuItem>Profile</MenuItem>
                            <MenuItem>Settings</MenuItem>
                            <MenuItem>Billing</MenuItem>
                            <MenuDivider/>
                            <MenuItem>Sign out</MenuItem>
                        </MenuList>
                    </Menu>
                </Flex>
            </HStack>
        </Flex>
    )
}